import React from 'react';
import PropTypes from 'prop-types';

const UPIVPA = ({ fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.3942 13.8835L14.6658 2.76517C14.5695 2.53613 14.4026 2.34382 14.1893 2.21626C13.9761 2.0887 13.7277 2.03255 13.4804 2.05598C13.233 2.07942 12.9996 2.18122 12.8141 2.34655C12.6286 2.51188 12.5008 2.73212 12.4492 2.97517L11.6675 5.55351L10.7108 8.93684L12.3208 12.0635L13.2775 8.66851L13.8725 6.54517L17.8042 14.1518L9.63749 21.7352L10.3842 19.0518L11.6675 14.6885L8.24916 17.7918L7.00082 22.1668L6.14916 25.1768C6.07671 25.4254 6.08898 25.6909 6.18402 25.9317C6.27907 26.1725 6.4515 26.3748 6.67415 26.5068C6.90113 26.6613 7.17531 26.7308 7.44845 26.703C7.7216 26.6753 7.97621 26.5521 8.16749 26.3552L20.1375 15.2835C20.3287 15.1112 20.4576 14.8804 20.504 14.6272C20.5505 14.374 20.5118 14.1125 20.3942 13.8835Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5866 13.0901L13.3232 8.66842L11.6666 5.55342L9.86991 1.97175C9.76411 1.75857 9.59564 1.58284 9.3871 1.46815C9.17857 1.35345 8.93994 1.30528 8.70324 1.33009C8.46352 1.34778 8.23511 1.4391 8.04925 1.59154C7.86339 1.74399 7.72916 1.95012 7.66491 2.18175L1.38824 24.3484C1.31758 24.5941 1.32954 24.8561 1.42228 25.0943C1.51502 25.3325 1.68342 25.5336 1.90158 25.6668C2.12186 25.8076 2.38307 25.8704 2.64329 25.845C2.90351 25.8196 3.14767 25.7075 3.33658 25.5268L6.99991 22.1668L10.3482 19.0634L15.3182 14.5018C15.5141 14.3302 15.6469 14.098 15.6955 13.8421C15.7442 13.5863 15.7058 13.3216 15.5866 13.0901ZM11.6666 14.6884L8.24824 17.7918L4.84158 21.0001L9.13491 5.83342L10.7566 8.93676L12.3666 12.0634L13.0432 13.3818L11.6666 14.6884Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.3666 10.8887H18.746C17.8472 10.8887 17.1111 11.4504 17.1111 12.1352V23.6421C17.1111 24.3281 17.8472 24.8887 18.7445 24.8887H26.3651C27.2639 24.8898 28 24.3281 28 23.6433V12.1363C28 11.4504 27.2639 10.8887 26.3666 10.8887ZM22.5563 22.2942C21.9725 22.2942 21.4977 22.6554 21.4977 23.1021C21.4977 23.5476 21.9725 23.9099 22.5563 23.9099C23.1416 23.9099 23.6149 23.5487 23.6149 23.1021C23.6149 22.6566 23.1401 22.2942 22.5563 22.2942ZM24.242 11.8982H20.8691C20.8453 11.8982 20.8244 11.9141 20.8244 11.9324V12.3084C20.8244 12.3266 20.8453 12.3426 20.8691 12.3426H24.242C24.2659 12.3426 24.2868 12.3278 24.2868 12.3084V11.9324C24.2868 11.913 24.2673 11.8982 24.242 11.8982ZM25.6667 13.3418H19.4444V21.7609H25.6667V13.3418Z"
      fill={fill || '#6B6C7B'}
    />
  </svg>
);

UPIVPA.propTypes = {
  fill: PropTypes.string,
};

export default UPIVPA;
